const pageWidth = document?.body?.offsetWidth;
const isDesktop = pageWidth > DESKTOP_WIDTH;

const handleInitProductCarouselSwiper = ({ id, isEnabled }) => {
  const isEnabledAsBool = isEnabled === 'true';
  const isSwiperEnable = isDesktop ? isEnabledAsBool : true;
  const paginationEnabled = {
    pagination: {
      el: `#swiper-pagination-${id}`,
      type: 'bullets',
    },
  };

  const navigationEnabled = {
    navigation: {
      nextEl: `#swiper-button-next-${id}`,
      prevEl: `#swiper-button-prev-${id}`,
    },
  };

  if (!isSwiperEnable) {
    const navigationWrapper = document.getElementById(
      `swiper-navigation-wrapper-${id}`
    );

    navigationWrapper?.classList?.add('!hidden');
  }

  const swiper = new Swiper(`#product-carousel-${id}`, {
    speed: DEFAULT_SLIDER_SPEED,
    spaceBetween: 4,
    loop: false,
    slidesPerView: 1.5,
    centeredSlides: false,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    init: isSwiperEnable,
    ...navigationEnabled,
    ...paginationEnabled,
    breakpoints: {
      [DESKTOP_WIDTH]: {
        slidesPerView: 4.5,
        spaceBetween: 16,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
      },
    },
    on: {
      init: function () {
        this?.el?.classList.remove('opacity-0');
        this?.wrapperEl?.classList.remove(
          'items-center',
          'justify-center',
          'gap-4'
        );
      },
    },
    watchOverflow: true,
  });

  return swiper;
};

const handleInitProductSlider = () => {
  const categorySliders = document?.querySelectorAll('.js-product-carousel');

  if (categorySliders?.length === 0) {
    return null;
  }

  categorySliders.forEach((element) =>
    handleInitProductCarouselSwiper({
      id: element?.dataset?.id,
      isEnabled: element?.dataset?.swiperEnable,
    })
  );

  new Swiper('.js-product-carousel-collections', {
    spaceBetween: 40,
    loop: false,
    slidesPerView: 'auto',
    centeredSlides: false,
    watchOverflow: true,
    centeredSlides: false,
    slidesOffsetAfter: 16,
    breakpoints: {
      [DESKTOP_WIDTH]: {
        spaceBetween: 48,
        slidesOffsetAfter: 32,
      },
    },
  });
};

const handleInitCollectionTitles = () => {
  const collectionTitles = document?.querySelectorAll('.js-collection-title');

  if (!collectionTitles?.length) {
    return null;
  }

  collectionTitles?.forEach((collectionTitle) => {
    collectionTitle.addEventListener('click', () => {
      const collectionId = collectionTitle.id;

      collectionTitles.forEach((el) => {
        el.classList.toggle('font-extrabold', el === collectionTitle);
        el.classList.toggle('font-light', el !== collectionTitle);
      });

      document.querySelectorAll('.js-collection-products').forEach((el) => {
        el.classList.toggle('hidden', el.dataset.id !== collectionId);
        el.classList.toggle('block', el.dataset.id === collectionId);
      });
    });
  });
};

const handleProductCarouselContainer = () => {
  const productCarouselContainer = document?.querySelectorAll(
    '.js-product-carousel-container'
  );

  if (!productCarouselContainer?.length) {
    return null;
  }

  productCarouselContainer?.forEach((el) => {
    el.classList.remove('opacity-0');
  });
};

handlePageLoadEvent(() => {
  document.addEventListener('readystatechange', (event) => {
    handleProductCarouselContainer();
    handleInitCollectionTitles();
    handleInitProductSlider();
  });
});

handleShopifyEditorEvent(() => {
  handleProductCarouselContainer();
  handleInitCollectionTitles();
  handleInitProductSlider();
});
